import { useEffect, useState, Suspense } from 'react'
import axios from 'axios'
import AnnouncePrivate from './components/announcePrivate'
import AnnounceLibertin from './components/announceLibertin'
import AnnounceEstablishment from './components/announceEstablishment'
import DashboardLayout from './layout'
import { useTranslation } from 'react-i18next'
import { API_BASE_URL, X_API_KEY } from '../../services/api'
import CookieManager from '../lib/CookiesManager'

interface FormProps {
  userProfileFormProps: any
  formData: any
  handleFieldChange: (field: string, value: any) => void
}

const AnnouncePage = () => {
  const [userStatus, setUserStatus] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    const fetchUserData = async () => {
      const email = CookieManager.getEmail()
      if (!email) {
        setIsLoading(false)
        return
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/all/full`, {
          headers: {
            'x-api-key': X_API_KEY,
          },
        })
        if (response.data?.users) {
          const user = response.data.users.find(
            (u: { email: string }) => u.email === email,
          )
          if (user?.status) {
            setUserStatus(
              Array.isArray(user.status) ? user.status : [user.status],
            )
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchUserData()
  }, [])

  const getFormComponent = (): React.ComponentType<FormProps> => {
    if (userStatus.includes('private, escort, massage')) {
      return AnnouncePrivate
    }
    if (
      userStatus.includes('maison privee') ||
      userStatus.includes(
        'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
      )
    ) {
      return AnnounceEstablishment
    }
    if (userStatus.includes('libertins ou visiteur')) {
      return AnnounceLibertin
    }
    return () => null
  }

  const FormComponent = getFormComponent()

  const handleFieldChange = (field: string, value: any) => {
    console.log('Field changed:', field, value)
  }

  if (isLoading) {
    return (
      <DashboardLayout title={t('dashboard.create-ad')}>
        <div className='flex justify-center items-center h-full'>
          {t('loading')}...
        </div>
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout title={t('dashboard.create-ad')}>
      <Suspense
        fallback={
          <div className='animate-spin rounded-full h-8 w-8 border-b-3 border-redpink'></div>
        }
      >
        <FormComponent
          userProfileFormProps={{}}
          formData={{}}
          handleFieldChange={handleFieldChange}
        />
      </Suspense>
    </DashboardLayout>
  )
}

export default AnnouncePage
